<template>
  <div>
    <skeleton-menu v-if="showLoader" />
    <div v-else>
      <ur-list-item>
        <div class="list-item__thumb">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21.462"
            height="21.027"
            viewBox="0 0 21.462 21.027"
          >
            <g
              id="Group_2540"
              data-name="Group 2540"
              transform="translate(-41.297 -192.499)"
            >
              <path
                id="Path_7909"
                data-name="Path 7909"
                d="M61.187,197.964a1.586,1.586,0,0,0,1.568-1.828c-.038-.652-.029-1.309,0-1.963A1.556,1.556,0,0,0,61.1,192.5c-2.45.032-4.9.01-7.351.01-3.624,0-7.247.01-10.871-.007A1.531,1.531,0,0,0,41.3,194.08c.011.774,0,1.548,0,2.323a1.5,1.5,0,0,0,.54,1.2,1.533,1.533,0,0,0,1.129.339v.313q0,4,0,8a2.4,2.4,0,0,0,1.066,2.076q3.293,2.344,6.584,4.692a2.369,2.369,0,0,0,2.933-.008c2.158-1.533,4.307-3.079,6.471-4.6a2.571,2.571,0,0,0,1.172-2.267c-.017-2.626-.006-5.252-.006-7.878Zm-1.7,9.555q-3.23,2.289-6.449,4.594a1.394,1.394,0,0,1-1.918,0q-3.234-2.3-6.469-4.607a1.45,1.45,0,0,1-.655-1.256q0-4.035,0-8.07c0-.069.01-.139.017-.217h16.15v.269q0,3.987,0,7.974A1.505,1.505,0,0,1,59.484,207.519Zm1.578-10.6H43.318c-.16,0-.32.006-.479,0a.451.451,0,0,1-.492-.514q0-1.161,0-2.323c0-.392.155-.543.556-.543H61.078c.5,0,.625.125.625.618q0,1.066,0,2.131C61.7,196.786,61.571,196.916,61.062,196.916Z"
                transform="translate(0 0)"
              />
              <path
                id="Path_7910"
                data-name="Path 7910"
                d="M180.552,327.49a7.032,7.032,0,0,0-.965-.155.413.413,0,0,1-.387-.283c-.092-.237-.217-.46-.332-.688a1.7,1.7,0,0,0-3.053-.01,3.09,3.09,0,0,0-.24.493.651.651,0,0,1-.709.516,3.1,3.1,0,0,0-.495.074,1.624,1.624,0,0,0-1.425,1.175,1.652,1.652,0,0,0,.481,1.788c.195.189.4.371.58.57a.338.338,0,0,1,.078.243c-.051.386-.121.77-.163,1.026a1.685,1.685,0,0,0,2.005,1.805,5.638,5.638,0,0,0,1.215-.535.364.364,0,0,1,.395.005c.255.148.516.286.782.411a1.686,1.686,0,0,0,2.42-1.68c-.03-.34-.111-.675-.149-1.015a.375.375,0,0,1,.088-.265c.211-.228.446-.433.662-.658A1.692,1.692,0,0,0,180.552,327.49Zm.009,2.113c-.281.3-.584.59-.885.875a.581.581,0,0,0-.182.563q.108.6.214,1.2a.65.65,0,0,1-.235.663.636.636,0,0,1-.718.081c-.371-.183-.736-.38-1.1-.578a.614.614,0,0,0-.635,0c-.349.191-.706.368-1.058.553a.647.647,0,0,1-.742-.035.667.667,0,0,1-.254-.721c.078-.374.132-.753.2-1.129a.636.636,0,0,0-.2-.625c-.287-.265-.559-.547-.838-.82a.638.638,0,0,1-.195-.714.677.677,0,0,1,.608-.463c.4-.055.8-.122,1.205-.177a.546.546,0,0,0,.437-.329c.176-.357.354-.713.528-1.071a.677.677,0,0,1,1.262,0c.169.352.346.7.515,1.051a.573.573,0,0,0,.472.354c.411.052.82.115,1.229.178a.751.751,0,0,1,.643.692A2.341,2.341,0,0,1,180.56,329.6Z"
                transform="translate(-125.256 -126.54)"
              />
            </g>
          </svg>
        </div>
        <div class="list-item__contents">
          <div class="list-item__contents__title">Favourites</div>
        </div>
      </ur-list-item>
      <ur-list-item
        v-for="(mItem, index) in side_menu"
        :key="index"
        :class="subIsActive(mItem) ? 'active-menu' : ''"
      >
        <div @click="switchMenu(mItem)" class="list-item-box">
          <div class="list-item__thumb">
            <component :is="icons[mItem.icon]"></component>
          </div>
          <div class="list-item__contents">
            <div class="list-item__contents__title">{{ mItem.title }}</div>
          </div>
        </div>
      </ur-list-item>
    </div>
    <!-- </ur-lnb> -->
    <div class="custom-submenu" v-if="showSideMenu">
      <div class="menu-holder">
        <h2>{{ sideMenuContent.title }}</h2>
        <ur-icon
          icon-type="line"
          icon="close"
          medium
          class="close-custom-submenu"
          @click="closeMenu"
        ></ur-icon>
        <div class="all-cards">
          <div
            class="item-card"
            v-for="(sMenu, mIndex) in sideMenuContent.subMenu"
            :key="mIndex"
          >
            <!-- @click="toggleSubMenu(sMenu)" -->
            <div
              class="
                d-flex
                justify-content-between
                position-relative
                mb-2
                item-heading
              "
            >
              <h3 class="m-0">{{ sMenu.title }}</h3>
              <!-- <ur-icon
                v-if="sMenu.subMenu.length"
                :class="sMenu.isOpen ? 'acc-icon' : 'acc-rotate-180'"
                icon-size="18"
                icon="collapse_menu"
              /> -->
            </div>
            <!-- <template v-if="sMenu.isOpen"> -->
            <template>
              <ul
                class="item-card-submenu"
                v-for="(subSmenu, sIndex) in sMenu.subMenu"
                :key="sIndex"
              >
                <li @click="redirectPage(subSmenu)">{{ subSmenu.title }}</li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuIcon from "@/services/menuIcon";
import { mapActions } from "vuex";
import PageLoader from "@/sisPageLoader.vue";
import SkeletonMenu from "./skeleton/SkeletonMenu.vue";

export default {
  name: "sidebar",
  components: { PageLoader, SkeletonMenu },
  data() {
    return {
      icons: menuIcon,
      side_menu: [],
      showSideMenu: false,
      sideMenuContent: {},
      activeObj: {},
      urlArray: [],
      showLoader: false,
    };
  },
  created() {
    this.showLoader = true;
    this.getUserMenu()
      .then((resp) => {
        this.showLoader = false;
        let dataItem = resp.data;
        this.setMenuUrl(dataItem);
        this.side_menu = dataItem;
      })
      .catch((err) => {});
  },
  methods: {
    ...mapActions(["getUserMenu"]),
    ...mapActions("sisMenus", ["updateMenuAction"]),

    go_home() {
      console.log("here is go_home");
    },
    toggleSubMenu(menuItem) {
      const tgData = this.sideMenuContent.subMenu.find(
        (it) => it.id == menuItem.id
      );
      tgData.isOpen = !menuItem.isOpen;

      const index = this.sideMenuContent.subMenu.findIndex(
        (it) => it.id == menuItem.id
      );
      const data = this.sideMenuContent;
      this.sideMenuContent = [];
      data.subMenu[index] = tgData;
      this.sideMenuContent = data;
    },
    redirectPage(item) {
      this.$router.push(item.url).catch(() => {});
      this.showSideMenu = false;
    },
    switchMenu(obj) {
      this.activeObj = obj;
      this.sideMenuContent = obj.menuBox;
      this.sideMenuContent.isOpen = true;
      this.showSideMenu = true;
    },
    closeMenu() {
      this.showSideMenu = false;
    },
    toggle_side(v) {
      this.$notify("Lnb Closed: " + v);
    },
    subIsActive(obj) {
      return this.activeObj.id === obj.id;
    },
    setMenuUrl(menus) {
      const menuBox = menus.map((menuItem) => menuItem.menuBox);
      this.fetchAllUrlFromMenu(menuBox);
      this.urlArray = [...this.urlArray, ...["/unauthorized", "/", "/404"]];
      this.updateMenuAction(this.urlArray);
    },
    fetchAllUrlFromMenu(menuBox) {
      menuBox.forEach((menuItem) => {
        if (menuItem?.url) {
          this.urlArray.push(menuItem.url);
        } else if (menuItem.subMenu) {
          this.fetchAllUrlFromMenu(menuItem.subMenu);
        }
      });
    },
  },
};
</script>
<style scoped>
.lnb-collapse-showcase.ur-lnb {
  position: relative;
  height: 500px;
  top: 0;
}
.lnb-collapse-showcase.ur-lnb .ur-lnb__search-wrapper {
  position: relative;
}
.lnb-collapse-showcase.ur-lnb .ur-lnb__menu-list-wrapper {
  width: 272px;
}
</style>
